export default {
  state: {
    // por consulta
    agendaData: {},
    agendaCreate: {},
    agendaAvaiable: {},
    // por exame
    agendaDataExam: {},
    agendaCreateExam: {},

    //vagas ociosas
    agendaPatients: [],
  },

  getters: {
    getAgendaData(state) {
      return state.agendaData;
    },
    getAgendaCreateData(state) {
      return state.agendaCreate;
    },
    getAgendaAvaiableData(state) {
      return state.agendaAvaiable;
    },

    // por exame
    getAgendaDataExam(state) {
      return state.agendaDataExam;
    },
    getAgendaCreateDataExam(state) {
      return state.agendaCreateExam;
    },

    //vagas ociosas
    getAgendaPatientsData(state) {
      return state.agendaPatients;
    },
  },
  mutations: {
    setAgendaData(state, data) {
      state.agendaData = data;
    },

    setAgendaCreateData(state, data) {
      const isNull = data === null;

      state.agendaCreate = {
        speciality: {
          codigo: !isNull ? data.speciality.codigo : null,
          descricao: !isNull ? data.speciality.descricao : null,
        },
        procedure: {
          codigo: !isNull ? data.procedure.codigo : null,
          descricao: !isNull ? data.procedure.descricao : null,
        },
        transportation_required: !isNull ? data.transportation_required : null,
        companion_required: !isNull ? data.companion_required : false,
        equipment_required: !isNull ? data.equipment_required : false,
        professional: {
          codigo: !isNull ? data.professional.codigo : null,
          descricao: !isNull ? data.professional.descricao : null,
        },
        monthConsult: !isNull ? data.monthConsult : null,
        yearConsult: !isNull ? data.yearConsult : null,
      };
    },

    setAgendaAvaiableData(state, data) {
      state.agendaAvaiable = data;
    },

    // por exame
    setAgendaDataExam(state, data) {
      state.agendaDataExam = data;
    },

    setAgendaCreateDataExam(state, data) {
      const isNull = data === null;

      state.agendaCreateExam = {
        executingUnityCode: !isNull ? data.executingUnityCode : [],
        groupCode: !isNull ? data.groupCode : [],
        Mneumonico: {
          desc_exame: !isNull ? data.Mneumonico.desc_exame : null,
          phi_exame: !isNull ? data.Mneumonico.phi_exame : null,
        },
        transportation_required: !isNull ? data.transportation_required : false,
        companion_required: !isNull ? data.companion_required : false,
        monthExam: !isNull ? data.monthExam : null,
        yearExam: !isNull ? data.yearExam : null,
        transplant_patient_exam: !isNull ? data.transplant_patient_exam : false,
        doctor: {
          name: !isNull ? data.doctor.name : null,
          crm: !isNull ? data.doctor.crm : null,
        },
        responsibleExam: {
          nome_responsavel: !isNull
            ? data.responsibleExam.nome_responsavel
            : null,
          cpf_responsavel: !isNull
            ? data.responsibleExam.cpf_responsavel
            : null,
          cod_grade: !isNull ? data.responsibleExam.cod_grade : null,
        },
      };
    },

    //vagas ociosas
    setAgendaPatientsData(state, data) {
      state.agendaPatients = data;
    },
  },
  actions: {
    changeAgendaData(context, infos) {
      context.commit("setAgendaData", infos);
    },

    changeAgendaCreateData(context, infos) {
      context.commit("setAgendaCreateData", infos);
    },

    changeAgendaAvaiableData(context, infos) {
      context.commit("setAgendaAvaiableData", infos);
    },

    // por exame
    changeAgendaDataExam(context, infos) {
      context.commit("setAgendaDataExam", infos);
    },

    changeAgendaCreateDataExam(context, infos) {
      context.commit("setAgendaCreateDataExam", infos);
    },

    //vagas ociosas
    changeAgendaPatientsData(context, infos) {
      context.commit("setAgendaPatientsData", infos);
    },
  },
};
